import cloneDeep from 'lodash.clonedeep';
import { useEffect, useState } from 'react';

import * as Client from 'api/client';
import { useAuth } from 'providers/Auth';
import { useShop } from 'providers/Shop';
import Context from './Context';

const Provider = ({ children }) => {
  const { validAuth, auth } = useAuth();
  const { products } = useShop();
  const [fetched, setFetched] = useState(false);
  const [carts, setCarts] = useState([]);
  const [customer] = useState({});
  const [discounts, setDiscounts] = useState([]);
  const [coupons, setCoupons] = useState([]);
  const [cartProducts] = useState([]);

  const getProduct = (id) =>
    products.find((product) => product.id === id) || {};

  const getErrorText = (res) => {
    if (Array.isArray(res))
      return res
        .filter((item) => !!item.message)
        .map((item) => {
          const productName = getProduct(item.productId).name || '';
          return `『${productName}』 ${item.message}`;
        })
        .join(', ');
    else if (res && typeof res === 'object' && res.message)
      return `『${getProduct(res.productId).name || ''}』 ${res.message}`;
    return;
  };

  function replace(carts) {
    return Client.replaceCart(auth.userId, auth.idToken, carts).then((res) => {
      let errorText = getErrorText(res);

      if (!res.err && !errorText) return fetchCarts();
      return { err: true, errorText, res };
    });
  }

  function update(cart) {
    return Client.updateCart(auth.userId, auth.idToken, cart).then((res) => {
      let errorText = getErrorText(res);
      if (!res.err && !errorText) return fetchCarts();
      return { err: true, errorText, res };
    });
  }

  function updateCoupon(coupons) {
    setCoupons(coupons);
    const newDiscount = coupons.reduce(
      (acc, { discount }) => {
        if (!acc.find(({ id }) => Number(id) === Number(discount.id)))
          acc.push(cloneDeep(discount));
        return acc;
      },
      [...discounts],
    );
    setDiscounts(newDiscount);
  }

  function fetchCarts() {
    // return Client.getCarts(auth.userId, auth.accessToken, auth.idToken)
    //   .then(({ carts, coupons, customer, discounts, products }) => {
    //     const sortCarts = carts.map((cart) => ({
    //       ...cart,
    //       rawProduct: products.find(({ id }) => id === cart.productID) || {},
    //     }));

    //     setCarts(sortCarts);
    //     setCustomer(customer);
    //     setDiscounts(discounts);
    //     setCoupons(coupons);
    //     setCartProducts(products);
    //     return { err: false };
    //   })
    //   .finally(() => {
    //     setFetched(true);
    //   });
    setFetched(true);
  }

  useEffect(() => {
    if (!validAuth || fetched) return;
    fetchCarts();
  }, [validAuth, auth]);

  const props = {
    carts,
    discounts,
    coupons,
    customer,
    fetched,
    cartProducts,
    // customerExtras: get(customer, EXTRA_INFO_PATH, {}),
    refresh: fetchCarts,
    replace,
    update,
    updateCoupon,
    setCarts,
  };

  return <Context.Provider value={{ ...props }}>{children}</Context.Provider>;
};

export default Provider;
